import React from "react"
import PropTypes from "prop-types"
import Map from "./Map";

class AirTritia extends React.Component {
  render() {
    return (
      <React.Fragment>
        {/*<h1>{this.props.title}</h1>*/}
        {/*<p>{this.props.forecast_info}</p>*/}
        <Map styleId={this.props.styleId}
             charts={this.props.charts}
             title={this.props.title}
             translations={this.props.translations}
             forecastInfo={this.props.forecastInfo}
        />
      </React.Fragment>
    );
  }
}

AirTritia.propTypes = {
  foo: PropTypes.string
};
export default AirTritia
